export default __webpack_public_path__ + "supportea5904.png";